/* istanbul ignore file - working example can be found in storybook.
 * better tested visually due to dependency on other components/structure */
import { Menu as MuiMenu, MenuItem as MuiMenuItem, type MenuItemProps, type MenuProps } from '@mui/material';
import { forwardRef } from 'react';
import styles from './PopoverMenu.module.scss';

export const PopoverMenu = forwardRef<HTMLDivElement, MenuProps>((props, ref) => (
  <MuiMenu
    {...props}
    ref={ref}
    classes={{
      paper: styles.popoverMenuPaper,
      ...props.classes,
    }}
  />
));

export const PopoverMenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => (
  <MuiMenuItem
    {...props}
    ref={ref}
    classes={{
      root: styles.popoverMenuItem,
      ...props.classes,
    }}
  />
));
